import { render, staticRenderFns } from "./AcompanharPedido.vue?vue&type=template&id=7cb8c8f3&scoped=true"
import script from "./AcompanharPedido.vue?vue&type=script&lang=js"
export * from "./AcompanharPedido.vue?vue&type=script&lang=js"
import style0 from "./AcompanharPedido.vue?vue&type=style&index=0&id=7cb8c8f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb8c8f3",
  null
  
)

export default component.exports